var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    width: 40,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 43 24",
    style: {
      enableBackground: "new 0 0 43 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.3,13.4c5.9,0,10.7,4.8,10.7,10.7H16.2c0-5.9,4.8-10.7,10.7-10.7H32.3z M16.2,13.4c0.8,0,1.6,0.1,2.3,0.3 c-3.1,2.5-5,6.2-5,10.5H0.2c0-5.9,4.8-10.7,10.7-10.7H16.2z M32.3,16.1h-5.4c-3.5,0-6.5,2.2-7.6,5.4h20.5 C38.8,18.3,35.8,16.1,32.3,16.1z M13,16.1h-2.1c-3.5,0-6.5,2.2-7.6,5.4h7.8C11.4,19.5,12.1,17.7,13,16.1z M13.6,0 c3,0,5.4,2.4,5.4,5.4c0,3-2.4,5.4-5.4,5.4S8.2,8.3,8.2,5.4C8.2,2.4,10.6,0,13.6,0z M29.6,0c3,0,5.4,2.4,5.4,5.4c0,3-2.4,5.4-5.4,5.4 s-5.4-2.4-5.4-5.4C24.3,2.4,26.7,0,29.6,0z M13.6,2.7c-1.5,0-2.7,1.2-2.7,2.7S12.1,8,13.6,8s2.7-1.2,2.7-2.7S15,2.7,13.6,2.7z  M29.6,2.7c-1.5,0-2.7,1.2-2.7,2.7S28.1,8,29.6,8c1.5,0,2.7-1.2,2.7-2.7S31.1,2.7,29.6,2.7z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.1f5bb035.svg";
export { ForwardRef as ReactComponent };